const SET_STATE = 'bodyMeasurementsReducer/SET_STATE'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setBodyMeasurementsState = (stateValues) => ({
  type: SET_STATE,
  payload: stateValues,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const bodyMeasurementsReducer = (state, action) => {
  if (action.type === SET_STATE) {
    return {
      ...state,
      ...action.payload,
    }
  }

  return state
}
